import * as actions from './metaConvConfig.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ExtMetaConvConfigModel } from '@smarttask-common/src/lib/models/Integrations/Meta/Conv/ExtMetaConvConfigModel';

export const configAdapter = createEntityAdapter<ExtMetaConvConfigModel>({
    selectId: (x) => x.config_id,
});
export interface MetaConvConfigState extends EntityState<ExtMetaConvConfigModel> {
    selected_config_id: number;
}

export const initialState: MetaConvConfigState = configAdapter.getInitialState({
    selected_config_id: undefined,
});

export function MetaConvConfigReducers(state: MetaConvConfigState = initialState, action: actions.MetaConvConfigActions) {
    switch (action.type) {
        case actions.MetaConvConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_config_id: action.selected_config_id };
            return state;

        case actions.MetaConvConfigActionTypes.ADD_META_CONV_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.MetaConvConfigActionTypes.ADD_META_CONV_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.MetaConvConfigActionTypes.UPSERT_META_CONV_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.MetaConvConfigActionTypes.UPSERT_META_CONV_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.MetaConvConfigActionTypes.UPDATE_META_CONV_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.MetaConvConfigActionTypes.UPDATE_META_CONV_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.MetaConvConfigActionTypes.DELETE_META_CONV_CONFIG:
            return configAdapter.removeOne(action.config_id, state);

        case actions.MetaConvConfigActionTypes.DELETE_META_CONV_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.MetaConvConfigActionTypes.DELETE_ALL_META_CONV_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.MetaConvConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getMetaConvConfigState = createFeatureSelector<MetaConvConfigState>('metaConvConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getMetaConvConfigState);

const getSelectedConfigIdState = (state: MetaConvConfigState) => {
    return state.selected_config_id;
};
export const getSelectedConfigId = createSelector(getMetaConvConfigState, getSelectedConfigIdState);

export const getSelectedConfig = createSelector(getMetaConvConfigState, (state: MetaConvConfigState) => {
    if (state.selected_config_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_config_id];
});
